import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import AccountCreation, {
    Input,
    Social
} from "@/components/signup/account-creation";
import { SocialProvider } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { InlineInputSubmitSocial } from "./components/inline-account-creation";

export type SignUpFormTextColor = "default" | "light";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
    textColor?: SignUpFormTextColor;
    inline?: boolean;
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const isTeamWacRefresh = checkFeatureFlagGate(
    featureFlags.wacRefreshTeam26Gate
);

const UniformSignUpForm = ({
    socialProviders,
    textColor = "default",
    inline = false
}: UniformSignUpProps) => {
    const intl = useIntl();

    const helpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperTextTeam26",
        defaultMessage:
            "Use a work email to find teams and get access to Rovo AI"
    });

    return (
        <div css={[textColor === "light" && lightTextColorCss]}>
            <AccountCreation
                Login={null}
                Separator={inline ? null : undefined}
                Error={inline ? null : undefined}
                Input={
                    inline ? (
                        <InlineInputSubmitSocial />
                    ) : isTeamWacRefresh ? (
                        <Input helpText={helpText} />
                    ) : undefined
                }
                Submit={inline ? null : undefined}
                Social={
                    inline ? null : socialProviders?.length ? (
                        <Social
                            providers={transformProviders(socialProviders)}
                        />
                    ) : undefined
                }
            />
        </div>
    );
};

export default UniformSignUpForm;

const lightTextColorCss = css({
    color: wacToken("color.neutral.light0")
});
